import { DEBUG_BUILD } from '../debug-build.js';
import { debug } from '../utils/debug-logger.js';
import { spanToJSON, getRootSpan, spanIsSampled } from '../utils/spanUtils.js';

/**
 * Print a log message for a started span.
 */
function logSpanStart(span) {
  if (!DEBUG_BUILD) return;
  var _spanToJSON = spanToJSON(span),
    _spanToJSON$descripti = _spanToJSON.description,
    description = _spanToJSON$descripti === void 0 ? '< unknown name >' : _spanToJSON$descripti,
    _spanToJSON$op = _spanToJSON.op,
    op = _spanToJSON$op === void 0 ? '< unknown op >' : _spanToJSON$op,
    parentSpanId = _spanToJSON.parent_span_id;
  var _span$spanContext = span.spanContext(),
    spanId = _span$spanContext.spanId;
  var sampled = spanIsSampled(span);
  var rootSpan = getRootSpan(span);
  var isRootSpan = rootSpan === span;
  var header = "[Tracing] Starting ".concat(sampled ? 'sampled' : 'unsampled', " ").concat(isRootSpan ? 'root ' : '', "span");
  var infoParts = ["op: ".concat(op), "name: ".concat(description), "ID: ".concat(spanId)];
  if (parentSpanId) {
    infoParts.push("parent ID: ".concat(parentSpanId));
  }
  if (!isRootSpan) {
    var _spanToJSON2 = spanToJSON(rootSpan),
      _op = _spanToJSON2.op,
      _description = _spanToJSON2.description;
    infoParts.push("root ID: ".concat(rootSpan.spanContext().spanId));
    if (_op) {
      infoParts.push("root op: ".concat(_op));
    }
    if (_description) {
      infoParts.push("root description: ".concat(_description));
    }
  }
  debug.log("".concat(header, "\n  ").concat(infoParts.join('\n  ')));
}

/**
 * Print a log message for an ended span.
 */
function logSpanEnd(span) {
  if (!DEBUG_BUILD) return;
  var _spanToJSON3 = spanToJSON(span),
    _spanToJSON3$descript = _spanToJSON3.description,
    description = _spanToJSON3$descript === void 0 ? '< unknown name >' : _spanToJSON3$descript,
    _spanToJSON3$op = _spanToJSON3.op,
    op = _spanToJSON3$op === void 0 ? '< unknown op >' : _spanToJSON3$op;
  var _span$spanContext2 = span.spanContext(),
    spanId = _span$spanContext2.spanId;
  var rootSpan = getRootSpan(span);
  var isRootSpan = rootSpan === span;
  var msg = "[Tracing] Finishing \"".concat(op, "\" ").concat(isRootSpan ? 'root ' : '', "span \"").concat(description, "\" with ID ").concat(spanId);
  debug.log(msg);
}
export { logSpanEnd, logSpanStart };